/* ═══════════════════════════════════════════════════════════════
   EroticShop — PDP Canlı Kargo Kesim Saati
   assets/pdp-shipping-cutoff.js  v1.0
   ───────────────────────────────────────────────────────────────
   Amaç: Ürün sayfasındaki urgency satırını Europe/Istanbul TZ'de
   canlı günceller. Config admin panelden gelir.

   States:
     active   → kalan > 30 dk  (brand / mor)
     critical → kalan ≤ 30 dk  (accent / kırmızı)
     missed   → cutoff geçti
     next     → bugün kapalı
   ═══════════════════════════════════════════════════════════════ */

(function () {
  'use strict';

  var cfg = window.__pdpShipCfg;
  if (!cfg) return;

  // Sayfada urgency elemanı hiç yoksa hiç başlama
  if (!document.querySelector('[data-pdp-urgency]')) return;

  // ── DOM referansları — her render'da tazelenir ──
  // Sebep: cart.js adet güncellemesinde .js-contents'in innerHTML'ini
  // komple değiştiriyor; tek seferlik sorgulanan root/body kopmuş
  // (detached) node'a dönüşüyor ve bar kalıcı kayboluyordu.
  var root = null;
  var body = null;
  var lastHtml = null;

  function syncRefs() {
    var el = document.querySelector('[data-pdp-urgency]');
    if (!el) return false;
    if (el !== root) {
      // Yeni node (cart güncellemesi sonrası) — cache sıfırla ki
      // setState innerHTML'i taze node'a yeniden yazsın
      root = el;
      body = el.querySelector('[data-pdp-urgency-body]');
      lastHtml = null;
    }
    return !!body;
  }

  // ── Sabitler ─────────────────────────────────────────────
  var DAY_NAMES = ['Pazar','Pazartesi','Salı','Çarşamba','Perşembe','Cuma','Cumartesi'];
  var MONTH_NAMES = ['Ocak','Şubat','Mart','Nisan','Mayıs','Haziran',
                     'Temmuz','Ağustos','Eylül','Ekim','Kasım','Aralık'];
  var CRITICAL_MIN  = 30;     // kalan ≤ 30 dk → kırmızı
  var TICK_MS       = 60000;  // dakikada bir render
  var MAX_LOOKAHEAD = 30;     // sonraki iş günü arama sınırı

  // ── Tatil parse: "GG.AA.YYYY" satırları → Set<"YYYY-MM-DD"> ──
  function parseDates(raw) {
    var out = new Set();
    if (!raw) return out;
    raw.split(/\r?\n/).forEach(function (line) {
      var t = line.trim();
      if (!t) return;
      var m = /^(\d{2})\.(\d{2})\.(\d{4})$/.exec(t);
      if (!m) {
        console.warn('[pdp-cutoff] Geçersiz tarih:', t, '→ format: GG.AA.YYYY');
        return;
      }
      out.add(m[3] + '-' + m[2] + '-' + m[1]);
    });
    return out;
  }

  var holidays = parseDates(cfg.holidays);
  var halfDays = parseDates(cfg.halfDays);

  // ── HTML escape (admin panel metinleri için) ─────────────
  var ESC = { '<':'&lt;', '>':'&gt;', '&':'&amp;', '"':'&quot;', "'":'&#39;' };
  function esc(s) {
    return String(s || '').replace(/[<>&"']/g, function (c) { return ESC[c]; });
  }

  // ── İstanbul şu anı (Intl TZ, DST-safe) ──────────────────
  var fmt = new Intl.DateTimeFormat('en-CA', {
    timeZone: 'Europe/Istanbul',
    year: 'numeric', month: '2-digit', day: '2-digit',
    hour: '2-digit', minute: '2-digit', hour12: false
  });

  function nowInIstanbul() {
    var parts = {};
    fmt.formatToParts(new Date()).forEach(function (p) {
      if (p.type !== 'literal') parts[p.type] = p.value;
    });
    var iso = parts.year + '-' + parts.month + '-' + parts.day;
    var h = parseInt(parts.hour, 10);
    if (h === 24) h = 0;  // en-CA bazen 24 döner
    var m = parseInt(parts.minute, 10);
    return { iso: iso, h: h, m: m, dow: dowOf(iso) };
  }

  // ── Tarih yardımcıları (UTC-anchored, TZ-safe) ───────────
  function dowOf(iso) {
    return new Date(iso + 'T12:00:00Z').getUTCDay();
  }
  function addDaysIso(iso, n) {
    var d = new Date(iso + 'T12:00:00Z');
    d.setUTCDate(d.getUTCDate() + n);
    return d.toISOString().slice(0, 10);
  }

  // ── Gün tipi: 'closed' | 'saturday' | 'weekday' ──────────
  function dayType(iso, dow) {
    if (holidays.has(iso)) return 'closed';
    if (dow === 0) return 'closed';                   // Pazar kapalı
    if (halfDays.has(iso) || dow === 6) return 'saturday';
    return 'weekday';
  }

  function cutoffFor(type) {
    if (type === 'weekday')  return { h: cfg.weekdayH, m: cfg.weekdayM };
    if (type === 'saturday') return { h: cfg.satH,     m: cfg.satM };
    return null;
  }

  function findNextWorkingDay(startIso) {
    var cur = startIso;
    for (var i = 0; i < MAX_LOOKAHEAD; i++) {
      cur = addDaysIso(cur, 1);
      if (dayType(cur, dowOf(cur)) !== 'closed') return cur;
    }
    return null;
  }

  function formatNextDay(iso) {
    var d = new Date(iso + 'T12:00:00Z');
    return DAY_NAMES[d.getUTCDay()] + ' ' +
           d.getUTCDate() + ' ' +
           MONTH_NAMES[d.getUTCMonth()];
  }

  function formatRemaining(totalMin) {
    var hrs  = Math.floor(totalMin / 60);
    var mins = totalMin % 60;
    if (hrs > 0 && mins > 0) return hrs + ' saat ' + mins + ' dakika içinde';
    if (hrs > 0)             return hrs + ' saat içinde';
    return mins + ' dakika içinde';
  }

  // ── State setter (DOM spam koruması) ─────────────────────
  function setState(state, html) {
    root.hidden = false;
    if (root.dataset.state !== state) root.dataset.state = state;
    if (lastHtml !== html) {
      body.innerHTML = html;
      lastHtml = html;
    }
  }

  // ── Ana render ───────────────────────────────────────────
  function render() {
    try {
      if (!syncRefs()) return;
      var now  = nowInIstanbul();
      var type = dayType(now.iso, now.dow);

      // Bugün kapalı → state: next
      if (type === 'closed') {
        var next = findNextWorkingDay(now.iso);
        if (!next) { root.hidden = true; return; }
        setState('next',
          '<span class="urg-label">' + esc(cfg.tplNext) + '</span> <strong>' + esc(formatNextDay(next)) + '</strong>');
        return;
      }

      // Bugün açık → cutoff kontrolü
      var co     = cutoffFor(type);
      var nowMin = now.h * 60 + now.m;
      var cutMin = co.h * 60 + co.m;
      var remaining = cutMin - nowMin;

      if (remaining > 0) {
        var s = (remaining <= CRITICAL_MIN) ? 'critical' : 'active';
        setState(s,
          '<strong>' + esc(formatRemaining(remaining)) + '</strong> ' + esc(cfg.tplToday));
        return;
      }

      // Cutoff geçti → state: missed
      var next2 = findNextWorkingDay(now.iso);
      if (!next2) { root.hidden = true; return; }
      setState('missed',
        '<span class="urg-label">' + esc(cfg.tplNext) + '</span> <strong>' + esc(formatNextDay(next2)) + '</strong>');

    } catch (err) {
      console.warn('[pdp-cutoff] Render hatası, satır gizleniyor:', err);
      root.hidden = true;
    }
  }

  // ── Tick döngüsü + tab visibility ────────────────────────
  var timer = null;
  function start() {
    render();
    stop();
    timer = setInterval(render, TICK_MS);
  }
  function stop() {
    if (timer) { clearInterval(timer); timer = null; }
  }
  document.addEventListener('visibilitychange', function () {
    if (document.hidden) stop();
    else start();
  });

start();

// ── Cart güncellemesi sonrası anında tazeleme ──
// Dawn cart.js, DOM değişiminden SONRA cartUpdate yayınlıyor →
// dakikalık tick'i beklemeden skeleton yerini metne bırakır.
// pubsub yüklü değilse sessizce atlanır (PDP güvenli).
if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
  subscribe(PUB_SUB_EVENTS.cartUpdate, function () { render(); });
}
})();